module.exports = __webpack_public_path__ + "static/media/fpBg.615d2899.png";